import { QueryFunctionContext } from '@tanstack/react-query';
import { UseTokenLookupQueryKey } from './props';
import { AxiosInstance, AxiosResponse } from 'axios';
import { TokenLookupInputDto } from '../../../../dto/withdrawals/token-lookup-input.dto';
import { TokenLookupOutputDto } from '../../../../dto/withdrawals/token-lookup-output.dto';

export async function fetchTokenLookup(
  { queryKey }: QueryFunctionContext<UseTokenLookupQueryKey>,
  axiosInstance: AxiosInstance,
): Promise<TokenLookupOutputDto> {
  const params: TokenLookupInputDto = queryKey[1];

  const response: AxiosResponse<TokenLookupOutputDto> =
    await axiosInstance.get<TokenLookupOutputDto>('/withdrawals/token-lookup', {
      params,
    });

  return response.data;
}
